// Alias
import Radio from '../radio/index';

export default Radio;



// WEBPACK FOOTER //
// ./components/radio-button-group/radio.jsx